export default __webpack_public_path__ + "static/media/FAQ_icon.b1809b47.svg";